import React, { useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../../Layout";
import { Data } from "../../../store/merchant/types";
import { getById } from "../../../store/merchant/queries";
import { fetchRequest as fetchMerchant } from "../../../store/merchant/actions";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import { Box } from "@mui/material";
import MerchantViewDetail from "./MerchantViewDetail";

export default function MerchantView() {
  const dispatch = useDispatch();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();
  const session = useSession();

  useEffect(() => {
    !isNil(id) && dispatch(fetchMerchant(id));
  }, []);

  const merchant = useSelector(id ? getById(id) : () => null) as Data;

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid xs={12}>
              <Paper>
                <PageHeading heading="View Merchant" />
              </Paper>
            </Grid>

            <Grid xs={12}>
              <Paper className={classes.paper}>
                {!isNil(id) && isNil(merchant) ? (
                  <ProgressIndicator />
                ) : (
                  <Box style={{ position: "relative" }}>
                    <MerchantViewDetail merchantData={merchant} />
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
